var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBeforeCash = function SvgBeforeCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BeforeCash_svg__a)",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.667H9.333a2.667 2.667 0 0 0-2.666 2.666v16A2.667 2.667 0 0 0 9.333 28h13.334a2.667 2.667 0 0 0 2.666-2.667v-16a2.667 2.667 0 0 0-2.666-2.666H20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.333 4h-2.666a2.667 2.667 0 1 0 0 5.333h2.666a2.667 2.667 0 1 0 0-5.333ZM18.667 14.667h-3.334a2 2 0 1 0 0 4h1.334a2 2 0 0 1 0 4h-3.334M16 22.667V24m0-10.667v1.334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "BeforeCash_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};

export default SvgBeforeCash;